import { Component, Inject, OnInit, ViewChild, ElementRef } from "@angular/core";
import { UntypedFormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FlowQueryModel } from "src/app/models/flowquerymodel";
import { BundleService } from "src/app/Services/bundleservice.service";
import { FlowServiceService } from "src/app/Services/flow-service.service";
import { UserserviceService } from "src/app/Services/userservice.service";
import { DataService } from "src/app/Services/dataservice.service";
import { EventEmitterService } from "src/app/Services/event-emitter.service";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { SupportDocumentComponent } from "../support-document/support-document.component";
import { ShowFlowImageDialogComponent } from "../show-flow-image-dialog/show-flow-image-dialog.component";
import { AuthModalService } from "src/app/Services/auth-modal.service";
import { catchError, take } from "rxjs/operators";
import { of } from "rxjs";
import { ReportReviewDialogComponent } from "../report-review-dialog/report-review-dialog.component";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-view-reported-flow",
  templateUrl: "./view-reported-flow.component.html",
  styleUrls: ["../viewflow/viewflow.component.scss", "./view-reported-flow.component.scss"],
})
export class ViewReportedFlowComponent implements OnInit {
  userData: any;
  flowData: any;
  noResultReturned: boolean;
  flowId: any;
  description: any;
  posterImageSource: any;
  nextCount: number;
  itemsRequired: number;
  stepCount: number;
  dataSource: any;
  progressBy: number;
  progressPercentage: number;
  IsSteps: boolean;
  likecolor: boolean;
  likeCount: any;
  bookmarkcolor: string;
  saveCount: any;
  viewsCount: any;
  viewText: string;
  groupedData: Record<string, any[]> = {};
  tempFlows: any[] = [];
  dataSourceSteps = [];
  showimage: boolean;
  showVideoOrImage: boolean;
  imageSource: any;
  selectedStepIndex: number = -2;
  stepNumber: any;
  isToggled: boolean = true;
  isLastSlide: boolean;
  isFirstSlide: boolean;
  expandedGroups: { [key: string]: boolean } = {};
  stepText: any;
  isFlowHomePage: boolean;
  coverPage: boolean;
  @ViewChild('stepButtons', { static: false }) stepButtons: ElementRef;
  newUrl: string;
  contentRowKey: string;
  videoPlayCounter: any = [];
  viewUnloaded: boolean;
  showDescriptionExpanded: boolean = false;
  showAll: boolean = false;
  // Reviews and Comments properties
  flowReviews: any[] = [];
  cachedAverageRating: number = 0;
  cachedTotalReviews: number = 0;
  cachedCustomersSaySummary: any = null;
  cachedReviewsWithImages: any[] = [];
  cachedTopReviews: any[] = [];
  hasUserReviewed: boolean = false;
  comments: any[] = [];
  commentsForm: any;
  profilePicture: string = '';
  isLoading: boolean = true;
  flowNotAvailable: boolean = false; // controls 'Flow Not Available' UI
  contentType: string = '';
  reportedContent: any = null;
  reportedReview: any = null;
  reportedComment: any = null;
  reviewRowKey: string = '';

  constructor(
    private dataService: DataService,
    private flowServiceService: FlowServiceService,
    private bundleService: BundleService,
    private toastr: ToastrService,
    public formbuilder: UntypedFormBuilder,
    public router: Router,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ViewReportedFlowComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public authModalService: AuthModalService
  ) {}
  async ngOnInit(): Promise<void> {
    this.userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (this.userData != null) {
      this.contentRowKey = this.data.contentId;
      this.contentType = this.data.contentType || '';
      this.reportedContent = this.data.reportedContent || null;
      this.reviewRowKey = this.data.reviewRowKey || '';
      this.isLoading = true;
      // Initialize comments form
      this.commentsForm = this.formbuilder.group({
        Comment: ["", Validators.required],
      });
      // Get profile picture
      if (this.userData && this.userData.profilePic) {
        this.profilePicture = this.userData.profilePic;
      }
      await this.getFlowDetails(this.contentRowKey);
    } else {
      this.router.navigate(["/"]);
    }
  }

  /**
   * Normalized check for Issue content type.
   * Handles variations like casing, whitespace, or suffixes (e.g. "Issue", "issue", "Issue Comment").
   */
  isIssueType(): boolean {
    return (this.contentType || "")
      .toString()
      .trim()
      .toLowerCase()
      .startsWith("issue");
  }

  copyCurrentLinkToClipboard() {
    navigator.clipboard
      .writeText(this.newUrl)
      .then(() => {
        this.toastr.success("Link copied to clipboard!");
      })
      .catch(() => {
        this.toastr.error("Failed to copy link.");
      });
  }

  updateUrlFragment() {
    let stepId = "";
    if (this.selectedStepIndex === -2) {
      stepId = "";
    } else if (this.selectedStepIndex === -1) {
      stepId = "itemsRequired";
    } else if (this.selectedStepIndex >= this.flowData.steps.length) {
      stepId = "";
      this.selectedStepIndex = -2;
      this.setCoverPage();
    } else if (this.selectedStepIndex >= 0) {
      stepId = `step${this.selectedStepIndex + 1}`;
    }

    // Build a guide URL for copying, but do NOT touch browser history from inside admin modal
    const slugTitle = this.generateUrlSlug(this.flowData.title);
    const baseUrl = `${environment.webBaseUrl}/guide/${slugTitle}/${this.flowData.rowKey}`;
    this.newUrl =
      this.selectedStepIndex == -2 ||
      this.selectedStepIndex >= this.flowData.steps.length
        ? `${baseUrl}`
        : `${baseUrl}#${stepId}`;
  }

  getFlowDetails(flowId) {
    this.noResultReturned = true;
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }

    var flowQueryModel = new FlowQueryModel({
      FlowId: flowId,
      userEmail: email,
    });

    this.flowServiceService.getFlowById(flowQueryModel).subscribe({
      next: (data) => {
        this.noResultReturned = false;
        this.isLoading = false;
        if (data.flows != null) {
          this.flowNotAvailable = false;
          this.flowData = data.flows;
          this.setFlowDetails();
        } else {
          this.handleFlowNotFoundError();
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.handleFlowNotFoundError(err);
      },
    });
  }

  private handleFlowNotFoundError(err?) {
    const errorMessage = err?.status
      ? "The flow you're trying to access is no longer available or may have been removed."
      : `We’re unable to display the content right now due to: ${
          err?.message || "an unexpected issue"
        }. Please try again later.`;

    // Show a non-blocking toast, but keep the admin in the modal
    this.toastr.info(errorMessage);

    // For any error / no-data case, mark flow as not available so UI shows the message
    this.flowNotAvailable = true;
    this.flowData = null;
    this.noResultReturned = false;
  }

  flowClicked(flow) {
    localStorage.setItem("notificationflowId", null);
    //localStorage.setItem("flow", JSON.stringify(flow));
    localStorage.removeItem("flow"); //, JSON.stringify(flow));
    localStorage.setItem("navigateTo", "/");

    if (flow.type == "Bundle") {
      //this.isItBundle = true;
      this.router.navigate(["/view-guide-pack/" + flow.rowKey]);
    } else {
      //this.isItBundle = false;
      this.router.navigate([
        `/guide/${this.generateUrlSlug(flow.title)}/${flow.rowKey}`,
      ]);
    }
  }

  generateUrlSlug(html) {
    if (!html) return "";
    return html
      .replace(/<[^>]*>/g, "") // Remove HTML tags
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove accents (é → e, ñ → n)
      .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters except spaces and "-"
      .trim() // Trim spaces from start/end
      .replace(/\s+/g, "-") // Replace spaces with "-"
      .replace(/-+/g, "-") // Remove duplicate dashes
      .toLowerCase(); // Convert to lowercase
  }

  viewUserProfile(selectedFlow) {
    if (this.userData != null) {
      if (this.userData.emailAddress === selectedFlow.customerEmail) {
        this.router.navigate(["/user-profile"]);
      } else {
        this.router.navigate(["/view-profile"]);
      }
      this.dataService.flowByCategorieschangeMessage(selectedFlow);
    } else {
      // Open registration modal instead of navigating to page
      this.authModalService.openModal('registration', this.router.url);
    }
  }
  setFlowDetails() {
    var lightBoxImage;
    this.showVideoFromFile(this.flowData.url);
    // this.imageSource = this.flowData.url;
    // this.imageSource = lightBoxImage;
    localStorage.setItem("flowUrl", JSON.stringify(this.imageSource));
    this.flowId = this.flowData.rowKey;
    this.description = this.flowData.description;
    this.posterImageSource = this.flowData.videoThumbNailUrl;
    this.nextCount = 0;
    this.itemsRequired = 0;
    this.stepCount = 0;
    var stepIncrementCount = 0;
    this.flowData.searchKeyWords = this.flowData.searchKeyWords
      ? this.flowData.searchKeyWords.split(", ").map((k) => k.trim())
      : [];
    localStorage.setItem("flow", JSON.stringify(this.flowData));
    const url = window.location.href;
    // this.titleandmetaserviceService.setCanonicalUrl(url);

    if (this.flowData === "default message") {
      this.flowData = JSON.parse(localStorage.getItem("recentflow"));
    }

    if (this.flowData.components.length > 0) {
      this.dataSource = this.flowData.components;
      this.groupDataByGroupName();
      stepIncrementCount = 2;
    } else {
      stepIncrementCount = 1;
    }

    localStorage.removeItem("pageIndex");
    localStorage.setItem("pageIndex", "0");
    this.getBundles("0");
    // Load reviews and comments after flow data is set
    if (this.flowData?.rowKey) {
      this.loadFlowReviews(this.flowData.rowKey);
      this.loadComments(this.flowData.rowKey);
    }
    const steps = this.flowData.steps.length + stepIncrementCount;
    this.progressBy = 100 / steps;
    this.progressPercentage = 100 / steps;

    if (this.flowData.steps.length > 0) {
      this.IsSteps = true;
      this.loadSteps(this.flowData.steps);
    } else {
      this.IsSteps = false;
    }

    if (this.flowData.isLiked === "liked") {
      this.likecolor = true;
      this.likeCount = this.flowData.likeCount;
    } else if (this.flowData.isLiked === "unliked") {
      this.likecolor = false;
      this.likeCount = this.flowData.likeCount;
    }

    if (this.flowData.isSaved === true) {
      this.bookmarkcolor = "#5ea1d8";
      this.saveCount = this.flowData.saveCount;
    } else {
      this.bookmarkcolor = "gray";
      this.saveCount = this.flowData.saveCount;
    }

    this.viewsCount = this.flowData.viewsCount;
    if (this.flowData.viewsCount > 1) {
      this.viewText = "Views";
    } else this.viewText = "View";
    
    // Initialize step navigation state
    this.selectedStepIndex = -2;
    this.setCoverPage();
    this.isFirstSlide = true;
    this.isLastSlide = false;
  }

  loadSteps(steps) {
    var stepNo = 0;
    steps.forEach((element) => {
      this.isImageOrVideo(element.url);
      this.dataSourceSteps.push({
        stepNo: stepNo + 1,
        title: element.title,
        url: element.url,
        description: element.description,
        id: element.rowKey,
        ShowImage: this.showimage,
      });
      stepNo++;
    });
    console.log(this.dataSourceSteps);
  }

  isImageOrVideo(url) {
    const imageExtensions = [
      "jpeg",
      "jpg",
      "png",
      "gif",
      "jfif",
      "tiff",
      "tif",
      "pdf",
      "bmp",
      "webp",
      "svg",
      "heic",
      "heif",
      "raw",
      "arw",
      "cr2",
      "nef",
      "orf",
      "rw2",
      "dng",
      "psd",
      "ico",
      "exif",
      "pjpeg",
      "ppm",
      "pgm",
      "pbm",
      "pnm",
      "xpm",
      "tga",
      "pcx",
      "jp2",
      "jpx",
      "eps",
      "ai",
    ];
    const videoExtensions = [
      "mp4",
      "mov",
      "wmv",
      "flv",
      "avchd",
      "webm",
      "mkv",
      "vob",
      "ogv",
      "gifv",
      "m4p",
      "m4v",
      "3gp",
      "3g2",
      "amv",
      "nsv",
      "ogg",
      "f4v",
      "f4p",
      "f4a",
      "f4b",
      "avi",
      "mts",
      "m2ts",
      "ts",
      "mpg",
      "mpeg",
      "rm",
      "rmvb",
      "divx",
      "xvid",
      "asf",
      "mxf",
      "dv",
      "h264",
      "h265",
      "vp8",
      "vp9",
      "prores",
      "swf",
      "dat",
      "bik",
      "av1",
      "vro",
      "svi",
    ];

    const lowerUrl = url.toLowerCase();

    if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showimage = true;
    } else if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showimage = false;
    }
  }

  getBundles(pageIndex): void {
    var flowModel = {
      rowKey: this.flowData.rowKey,
      partitionKey: this.flowData.customerEmail,
    };

    this.bundleService
      .getBundlesByFlowId(flowModel, pageIndex)
      .subscribe((data) => {
        console.log(data);
        if (!this.tempFlows) {
          this.tempFlows = [];
        }
        data?.forEach((element) => {
          // Set showImage property based on URL extension
          if (element.url) {
            element.showImage = this.isImageUrl(element.url);
          }
          this.tempFlows.push(element);
        });
        localStorage.setItem("BundleListToShare", JSON.stringify(this.tempFlows));
      });
  }

  private isImageUrl(url: string): boolean {
    if (!url) return false;
    
    const imageExtensions = [
      "jpeg", "jpg", "png", "gif", "jfif", "tiff", "tif", "pdf",
      "bmp", "webp", "svg", "heic", "heif", "raw", "arw", "cr2",
      "nef", "orf", "rw2", "dng", "psd", "ico", "exif", "pjpeg",
      "ppm", "pgm", "pbm", "pnm", "xpm", "tga", "pcx", "jp2",
      "jpx", "eps", "ai"
    ];
    
    const lowerUrl = url.toLowerCase();
    return imageExtensions.some((ext) => lowerUrl.includes(ext));
  }

  groupDataByGroupName() {
    if (!this.dataSource || this.dataSource.length === 0) {
      this.groupedData = {}; // Ensure no errors on empty or undefined data
      return;
    }

    this.groupedData = this.dataSource.reduce((acc, item) => {
      const group = item.groupName || ""; // Default group if missing
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(item);
      return acc;
    }, {} as Record<string, any[]>);
  }

  selectStepAdvanced(index: number) {
    this.selectedStepIndex = index;
    this.itemsRequired = 0;
    this.coverPage = false;
    this.isFlowHomePage = false;
    this.stepNumber = 0;
    this.nextCount = 0;
    this.stepCount = 0;
    this.isLastSlide = false;
    if (index === -2) {
      this.setCoverPage();
    } else if (index === -1) {
      this.setItemsPage();
    } else {
      this.setStep(index);
    }
    this.updateUrlFragment();

    this.scrollToStep();
  }

  NextStep() {
    this.imageSource = null;
    this.description = null;
    this.selectedStepIndex = this.selectedStepIndex + 1;
    this.itemsRequired = 0;
    this.coverPage = false;
    this.isFlowHomePage = false;
    this.stepNumber = 0;
    this.nextCount = 0;
    this.stepCount = 0;
    this.isFirstSlide = false;
    this.scrollToStep();
    if (this.selectedStepIndex === -2) {
      this.setCoverPage();
    } else if (this.selectedStepIndex === -1) {
      if (this.flowData.components.length <= 0) {
        this.selectedStepIndex = this.selectedStepIndex + 1;
        this.setStep(this.selectedStepIndex);
        if (this.selectedStepIndex + 1 === this.flowData.steps.length) {
          this.isLastSlide = true;
        }
      } else {
        this.setItemsPage();
      }
    } else {
      this.setStep(this.selectedStepIndex);
      if (this.selectedStepIndex + 1 === this.flowData.steps.length) {
        this.isLastSlide = true;
      }
    }
    this.updateUrlFragment();
  }

  PreviousStep() {
    this.imageSource = null;
    this.description = null;
    this.selectedStepIndex = this.selectedStepIndex - 1;
    this.itemsRequired = 0;
    this.coverPage = false;
    this.isFlowHomePage = false;
    this.stepNumber = 0;
    this.nextCount = 0;
    this.stepCount = 0;
    this.isFirstSlide = false;
    this.isLastSlide = false;
    this.scrollToStep();
    if (this.selectedStepIndex === -2) {
      this.setCoverPage();
      this.isFirstSlide = true;
    } else if (this.selectedStepIndex === -1) {
      if (this.flowData.components.length <= 0) {
        this.selectedStepIndex = this.selectedStepIndex - 1;
        this.setCoverPage();
        this.isFirstSlide = true;
      } else {
        this.setItemsPage();
      }
    } else {
      this.setStep(this.selectedStepIndex);
    }
    this.updateUrlFragment();
  }

  scrollToStep() {
    setTimeout(() => {
      if (!this.stepButtons?.nativeElement) {
        console.warn("stepButtons not found!");
        return;
      }

      const container = this.stepButtons.nativeElement;
      const buttons = container.children;
      const selectedButton = buttons[this.selectedStepIndex + 2]; // +2 to skip Cover & Items

      if (selectedButton) {
        // Ensure smooth scrolling and alignment
        selectedButton.scrollIntoView({
          behavior: "smooth",
          block: "nearest", // Keeps it inside the container
          inline: "center", // Centers it in horizontal scroll
        });
      }
    }, 100);
  }

  private setCoverPage() {
    this.isFlowHomePage = this.coverPage = true;
    this.imageSource = this.flowData.url;
    this.description = this.flowData.description;
    this.posterImageSource = this.flowData.videoThumbNailUrl;
    this.isFirstSlide = true;
    this.showVideoFromFile(this.flowData.url);
  }

  private setItemsPage() {
    this.description = this.stepText;
    this.itemsRequired = 1;
    this.nextCount = 1;
    this.stepCount = 0;
    this.isFirstSlide = false;

    Object.keys(this.groupedData).forEach((groupKey) => {
      this.expandedGroups[groupKey] = true;
    });
  }

  private setStep(index: number) {
    this.isFirstSlide = false;
    if (this.selectedStepIndex + 1 === this.flowData.steps.length) {
      this.isLastSlide = true;
    }
    // this.CheckUserLoggedIn();
    const step = this.flowData.steps[index];
    console.log(`Step ${this.stepNumber} selected`, step);
    if (!step) return; // Prevent potential errors
    if (this.isToggled) {
      this.setStepData(index);
    } else {
      this.imageSource = step.url;
      this.description = step.description;
      this.showVideoFromFile(this.imageSource);
      localStorage.setItem("imageSource", JSON.stringify(this.imageSource));
      this.stepNumber = index + 1;
      this.stepCount = index + 1;
      this.nextCount = index + 1;
      console.log(`Step ${this.stepNumber} selected`);
    }
  }

  showVideoFromFile(filePath: string) {
    var path = this.getExtension(filePath);
    if (
      path.includes("MP4") ||
      path.includes("mp4") ||
      path.includes("MOV") ||
      path.includes("mov") ||
      path.includes("WMV") ||
      path.includes("wmv") ||
      path.includes("FLV") ||
      path.includes("flv") ||
      path.includes("AVCHD") ||
      path.includes("avchd") ||
      path.includes("WEBM") ||
      path.includes("webm") ||
      path.includes("MKV") ||
      path.includes("mkv") ||
      path.includes("VOB") ||
      path.includes("vob") ||
      path.includes("OGV") ||
      path.includes("ogv") ||
      path.includes("GIFY") ||
      path.includes("gifv") ||
      path.includes("M4P") ||
      path.includes("m4p") ||
      path.includes("M4V") ||
      path.includes("m4v") ||
      path.includes("3GP") ||
      path.includes("3gp") ||
      path.includes("3G2") ||
      path.includes("3g2") ||
      path.includes("AMV") ||
      path.includes("amv") ||
      path.includes("NSV") ||
      path.includes("nsv") ||
      path.includes("OGG") ||
      path.includes("ogg") ||
      path.includes("FLV") ||
      path.includes("flv") ||
      path.includes("F4V") ||
      path.includes("f4v") ||
      path.includes("F4P") ||
      path.includes("f4p") ||
      path.includes("F4A") ||
      path.includes("f4a") ||
      path.includes("F4B") ||
      path.includes("f4b")
    ) {
      this.showVideoOrImage = true;
      this.imageSource = filePath;
    } else {
      this.showVideoOrImage = false;
      this.imageSource = filePath;
    }
    console.log(this.showVideoOrImage);
  }

  setStepData(index) {
    this.selectedStepIndex = index;
    const step = this.flowData.steps[index];
    if (!step) return; // Prevent potential errors
    
    // Set the step data
    this.imageSource = step.url;
    this.description = step.description;
    this.stepNumber = index + 1;
    this.stepCount = index + 1;
    this.nextCount = index + 1;
    
    // Determine if it's video or image
    var path = this.getExtension(step.url);

    const imageExtensions = [
      "jpeg",
      "jpg",
      "png",
      "gif",
      "jfif",
      "tiff",
      "tif",
      "pdf",
      "bmp",
      "webp",
      "svg",
      "heic",
      "heif",
      "raw",
      "arw",
      "cr2",
      "nef",
      "orf",
      "rw2",
      "dng",
      "psd",
      "ico",
      "exif",
      "pjpeg",
      "ppm",
      "pgm",
      "pbm",
      "pnm",
      "xpm",
      "tga",
      "pcx",
      "jp2",
      "jpx",
      "eps",
      "ai",
    ];
    const videoExtensions = [
      "mp4",
      "mov",
      "wmv",
      "flv",
      "avchd",
      "webm",
      "mkv",
      "vob",
      "ogv",
      "gifv",
      "m4p",
      "m4v",
      "3gp",
      "3g2",
      "amv",
      "nsv",
      "ogg",
      "f4v",
      "f4p",
      "f4a",
      "f4b",
      "avi",
      "mts",
      "m2ts",
      "ts",
      "mpg",
      "mpeg",
      "rm",
      "rmvb",
      "divx",
      "xvid",
      "asf",
      "mxf",
      "dv",
      "h264",
      "h265",
      "vp8",
      "vp9",
      "prores",
      "swf",
      "dat",
      "bik",
      "av1",
      "vro",
      "svi",
    ];

    const lowerUrl = path.toLowerCase();

    if (imageExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showVideoOrImage = false; // It's an image
    } else if (videoExtensions.some((ext) => lowerUrl.includes(ext))) {
      this.showVideoOrImage = true; // It's a video
    } else {
      // Default: use showVideoFromFile to determine
      this.showVideoFromFile(step.url);
      return; // showVideoFromFile already sets imageSource and showVideoOrImage
    }
    
    // Ensure showVideoFromFile is called to properly initialize the media
    this.showVideoFromFile(step.url);
    localStorage.setItem("imageSource", JSON.stringify(this.imageSource));
    console.log(`Step ${this.stepNumber} selected`, step, 'showVideoOrImage:', this.showVideoOrImage);
  }

  isSeparator(value: string) {
    if (value === "/" || value === "\\" || value === ":") return true;
  }

  getExtension = (path: string): string => {
    for (let i = path.length - 1; i > -1; --i) {
      const value = path[i];
      if (value === ".") {
        if (i > 1) {
          if (this.isSeparator(path[i - 1])) {
            return "";
          }
          return path.substring(i + 1);
        }
        return "";
      }
      if (this.isSeparator(value)) {
        return "";
      }
    }
    return "";
  };

  takeDown() {
    this.dialogRef.close(true); // user chose "yes"
  }

  markAsFine() {
    this.dialogRef.close(false); // user chose "no"
  }
  close() {
    this.dialogRef.close(); // user chose "no"
  }

  stopVideo(index: number) {
    setTimeout(() => {
      const videos = document.querySelectorAll("video");
      if (videos[index]) {
        videos[index].pause();
        videos[index].currentTime = 0; // Reset to the beginning
      }
    }, 100); // Adding a slight delay to ensure panel closing animation is smooth
  }

  playVideo(index: number) {
    setTimeout(() => {
      const videos = document.querySelectorAll("video");
      if (videos[index]) {
        videos[index]
          .play()
          .catch((error) => console.error("Error playing video:", error));
      }
    }, 300); // Adding a slight delay to ensure smooth expansion
  }

  toggleGroup(groupKey: string): void {
    this.expandedGroups[groupKey] = !this.expandedGroups[groupKey]; // Toggle
  }

  vidEnded(event) {
    var playcount = 0;
    var video = this.videoPlayCounter.filter(
      (v) => v.currentSrc == event.target.currentSrc
    );
    if (video != null) {
      playcount = video.length;
    }

    if (playcount < 3) {
      this.videoPlayCounter.push({
        eventobj: event,
        currentSrc: event.target.currentSrc,
        playcount: playcount,
      });
      event.target.play();
    }
  }

  vidfocus(event) {}

  vidplay(event) {
    if (!this.viewUnloaded) {
      var videos = this.videoPlayCounter.filter((v) => v.id == event.target.id);

      if (videos.length > 3) {
        videos.forEach((element) => {
          var obj = this.videoPlayCounter.indexOf(element);

          if (obj > -1) {
            this.videoPlayCounter.splice(obj, 1);
          }
        });
      }
      event.target.play();
    }
  }

  openLink(iname) {
    var url = iname.wheretofindit;
    // if (this.isPurchaseRequired) return;
    // else {
    if (url.includes("https://")) {
      url = url;
      window.open(url);
      // this.recordLinkClick(iname);
    } else {
      url = "https://" + url;
      window.open(url);
      // this.recordLinkClick(iname);
    }
    // }
  }

  ViewSupportingDocuments() {
    if (this.flowData.isPaid && this.userData == null) {
      // this.router.navigate(['/login'], {
      //   queryParams: { returnUrl: this.router.url }
      // });
      localStorage.setItem("returnUrl", this.router.url);
      this.router.navigate(["/registration"]);
    } else {
      //this.router.navigate(["/in-Appropriate"]);
      localStorage.setItem("flowData", JSON.stringify(this.flowData));
      const dialogRef = this.dialog.open(SupportDocumentComponent, {
        panelClass: "dialoguebox",
      });
      dialogRef.afterClosed().subscribe((result) => {});
    }
  }

  showFlowImage(imageSource) {
    localStorage.removeItem("itemsRequiredImageToShow");
    localStorage.setItem("flowImageToShow", imageSource);
    this.dialog.open(ShowFlowImageDialogComponent, {
      panelClass: ["media-dialog-pane", "media-dialog"],
      backdropClass: "custom-backdrop",
      maxWidth: "95vw",
      width: "auto",
      maxHeight: "95vh",
      height: "auto",
      autoFocus: false,
      restoreFocus: false,
    });
  }

  openImage(Url) {
    localStorage.setItem("itemsRequiredImageToShow", Url);

    this.dialog.open(ShowFlowImageDialogComponent, {
      panelClass: ["media-dialog-pane", "media-dialog"],
      backdropClass: "custom-backdrop",
      maxWidth: "95vw",
      width: "auto",
      maxHeight: "95vh",
      height: "auto",
      autoFocus: false,
      restoreFocus: false,
    });
  }

  // Reviews and Comments methods
  loadFlowReviews(flowId: string): void {
    if (!flowId) {
      this.flowReviews = [];
      this.updateCachedReviewValues();
      return;
    }

    const email = this.userData?.emailAddress ?? '';

    this.flowServiceService
      .getFlowReviews({ FlowRowKey: flowId })
      .pipe(
        catchError((error) => {
          console.error('Error loading flow reviews:', error);
          this.flowReviews = [];
          this.updateCachedReviewValues();
          return of({ reviews: [] });
        })
      )
      .subscribe((data: any) => {
        try {
          if (!data) {
            this.flowReviews = [];
            this.updateCachedReviewValues();
            return;
          }

          // API returns { reviews: [...] }, so extract reviews array
          const reviews = (data.reviews || data || []) as any[];
          this.flowReviews = reviews || [];
          
          // Check if user has reviewed
          this.hasUserReviewed = email && reviews.length > 0
            ? reviews.some(r => (r.email === email || r.CreatedByUserEmail === email))
            : false;
          
          // Update cached values
          this.updateCachedReviewValues();
          
          // Find the reported review if contentType is Review or Issue
          if ((this.contentType === 'Review' || this.isIssueType()) && this.reviewRowKey) {
            this.reportedReview = this.flowReviews.find(r => 
              r.rowKey === this.reviewRowKey || 
              r.reviewRowKey === this.reviewRowKey ||
              r.id === this.reviewRowKey
            );
          }
          
          // Scroll to review section if contentType is Review or Issue (after reviews are loaded)
          if ((this.contentType === 'Review' || this.isIssueType()) && this.flowReviews.length > 0) {
            setTimeout(() => {
              this.scrollToReviewSection();
            }, 300);
          }
        } catch (error) {
          console.error('Error processing flow reviews:', error);
          this.flowReviews = [];
          this.updateCachedReviewValues();
        }
      });
  }

  loadComments(flowId: string): void {
    if (!flowId || !this.flowData) {
      this.comments = [];
      return;
    }

    this.comments = [];
    var email = "";
    if (this.userData != null && this.userData != undefined) {
      email = this.userData.emailAddress;
    }
    
    var flowQueryModel = new FlowQueryModel({
      category: "",
      searchString: "",
      userEmail: email,
      pageIndex: 0,
      partitionKey: flowId,
    });
    
    this.flowServiceService
      .getUsersFlowComments(flowQueryModel)
      .pipe(
        catchError((error) => {
          console.error('Error loading comments:', error);
          this.comments = [];
          return of({ flowComments: [] });
        })
      )
      .subscribe((data) => {
        if (data && data.flowComments && data.flowComments.length > 0) {
          data.flowComments.forEach((element) => {
            if (
              this.userData &&
              this.userData.emailAddress === element.commentedByUserEmail
            ) {
              element.isFlowOwner = true;
            }
            this.comments.push(element);
          });
          
          // Find the reported comment if contentType is Issue
          if (this.isIssueType() && this.contentRowKey) {
            // For Issue type, contentId might be the comment rowKey
            this.reportedComment = this.comments.find(c => 
              c.rowKey === this.contentRowKey || 
              c.commentId === this.contentRowKey ||
              c.id === this.contentRowKey ||
              c.RowKey === this.contentRowKey
            );
          }
        }
      });
  }

  private updateCachedReviewValues(): void {
    if (!this.flowReviews || this.flowReviews.length === 0) {
      this.cachedAverageRating = 0;
      this.cachedTotalReviews = 0;
      this.cachedCustomersSaySummary = null;
      this.cachedReviewsWithImages = [];
      this.cachedTopReviews = [];
      return;
    }

    // Calculate average rating
    const reviewsWithRating = this.flowReviews.filter(r => r.rating && r.rating > 0);
    if (reviewsWithRating.length === 0) {
      this.cachedAverageRating = 0;
    } else {
      const sum = reviewsWithRating.reduce((acc, review) => acc + (review.rating || 0), 0);
      this.cachedAverageRating = Math.round((sum / reviewsWithRating.length) * 10) / 10;
    }

    // Calculate total reviews
    this.cachedTotalReviews = this.flowReviews.length;

    // Get reviews with images
    this.cachedReviewsWithImages = this.flowReviews.filter(r => r.mediaUrl && r.mediaUrl.trim() !== '');

    // Get top reviews (sorted by rating, then by date)
    this.cachedTopReviews = [...this.flowReviews]
      .sort((a, b) => {
        if (b.rating !== a.rating) {
          return (b.rating || 0) - (a.rating || 0);
        }
        const dateA = new Date(a.createdDate || 0).getTime();
        const dateB = new Date(b.createdDate || 0).getTime();
        return dateB - dateA;
      })
      .slice(0, 10);

    // Generate customers say summary (simplified version)
    if (this.cachedTotalReviews > 0) {
      const positiveReviews = reviewsWithRating.filter(r => r.rating >= 4).length;
      const percentage = Math.round((positiveReviews / reviewsWithRating.length) * 100);
      this.cachedCustomersSaySummary = {
        percentage: percentage,
        total: this.cachedTotalReviews
      };
    } else {
      this.cachedCustomersSaySummary = null;
    }
  }

  openReviewDialog(): void {
    this.toastr.info("Review functionality is read-only in admin view");
  }

  markReviewHelpful(event: any): void {
    this.toastr.info("Review actions are read-only in admin view");
  }

  reportReview(review: any): void {
    if (!review) {
      return;
    }

    // Check if user is logged in
    const userData = JSON.parse(localStorage.getItem("LoggedInUser"));
    if (!userData || !userData.emailAddress) {
      this.toastr.error("Please login to report this review");
      return;
    }

    // Check if user has already reported this review
    if (this.flowData?.rowKey && review.rowKey) {
      this.flowServiceService.checkIfUserReportedReview(review.rowKey, this.flowData.rowKey)
        .pipe(take(1))
        .subscribe(
          (response) => {
            if (response && response.hasReported) {
              this.toastr.info("You have already submitted a report for this review.");
              return;
            }

            // User hasn't reported, open the dialog
            const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
              width: "520px",
              maxWidth: "95vw",
              data: {
                review,
                flowData: this.flowData,
              },
              panelClass: "dialoguebox",
            });

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.toastr.info("Review reported. Thank you for your feedback.");
                // Reload reviews to update reported status
                if (this.flowData?.rowKey) {
                  this.loadFlowReviews(this.flowData.rowKey);
                }
              }
            });
          },
          (error) => {
            console.error("Error checking if user reported review", error);
            // On error, still allow reporting (fail open)
            const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
              width: "520px",
              maxWidth: "95vw",
              data: {
                review,
                flowData: this.flowData,
              },
              panelClass: "dialoguebox",
            });

            dialogRef.afterClosed().subscribe((result) => {
              if (result) {
                this.toastr.info("Review reported. Thank you for your feedback.");
                // Reload reviews to update reported status
                if (this.flowData?.rowKey) {
                  this.loadFlowReviews(this.flowData.rowKey);
                }
              }
            });
          }
        );
    } else {
      // If flowData or review rowKey is missing, still allow reporting
      const dialogRef = this.dialog.open(ReportReviewDialogComponent, {
        width: "520px",
        maxWidth: "95vw",
        data: {
          review,
          flowData: this.flowData,
        },
        panelClass: "dialoguebox",
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.toastr.info("Review reported. Thank you for your feedback.");
          // Reload reviews to update reported status
          if (this.flowData?.rowKey) {
            this.loadFlowReviews(this.flowData.rowKey);
          }
        }
      });
    }
  }

  showReviewsInfo(): void {
    // Can be implemented if needed
  }

  showFlowIssuesDialog(): void {
    // Can be implemented if needed
  }

  addComment(event: any): void {
    event.preventDefault();
    this.toastr.info("Comment functionality is read-only in admin view");
  }

  likeComment(comment: any): void {
    this.toastr.info("Comment actions are read-only in admin view");
  }

  replyToComment(comment: any): void {
    this.toastr.info("Comment actions are read-only in admin view");
  }

  checkIsUserLoggedIn(): void {
    if (!this.userData) {
      this.authModalService.openModal('login');
    }
  }

  scrollToReviewSection(): void {
    setTimeout(() => {
      const reviewSection = document.getElementById('customer-feedback-section') || 
                            document.querySelector('app-customer-feedback-section');
      if (reviewSection) {
        reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 500);
  }
}
